import { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const localizer = momentLocalizer(moment);

export default function AppointmentCalendar() {
    const [events, setEvents] = useState([]);
    const [view, setView] = useState("month");
    const [date, setDate] = useState(new Date());

    const user = JSON.parse(localStorage.getItem("user") || "{}");

    useEffect(() => {
        if (!user?.id) return;

        fetch(`${API}/api/appointments/user/${user.id}`)
            .then(res => res.json())
            .then((data) => {
                const appts = Array.isArray(data) ? data : data.data || [];

                const formatted = appts.map((a) => {
                    const start = new Date(a.date);
                    const [h, m] = a.time.split(":").map(Number);
                    start.setHours(h, m);

                    const end = new Date(start);
                    end.setMinutes(end.getMinutes() + (a.duration || 30));

                    return {
                        title: `Dr. ${a.doctor_name}`,
                        start,
                        end,
                        status: a.status
                    };
                });

                setEvents(formatted);
            });
    }, [user.id]);



    return (
        <div style={{ height: "80vh", width: "100%" }}>
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"

                view={view}                 // ✅ controlled view
                onView={(v) => setView(v)}  // ✅ update when clicked

                date={date}                 // ✅ controlled date
                onNavigate={(d) => setDate(d)} // ✅ next/back works

                views={["month", "week", "day"]}
                toolbar={true}

                style={{ height: "100%" }}

                eventPropGetter={(event) => {
                    let bg = "#0284c7";

                    if (event.status === "completed") bg = "#16a34a";
                    if (event.status === "cancelled") bg = "#dc2626";

                    return {
                        style: {
                            backgroundColor: bg,
                            color: "white",
                            borderRadius: "8px",
                            border: "none",
                        },
                    };
                }}
            />
        </div>
    );
}